import { child, getDatabase, ref } from "firebase/database";
import { v4 as uuidv4 } from "uuid";

let refs = new Map();

function schemaToRefs(obj, path = "") {
  Object.entries(obj).forEach(([key, val]) => {
    let newPath = path;
    const hasChildren = typeof val === "object" && Object.keys(val).length > 0;
    newPath += newPath ? `/${key}` : key;
    refs.set(obj, path);
    // if (typeof val == "string") {
    //   console.log(val, newPath);
    // }

    if (hasChildren) {
      schemaToRefs(val, newPath);
    }
  });
}

export function getRef(url, urlParams = {}) {
  let urlStr = refs.get(url);
  if (!urlStr) throw new Error(`Could not find url: ${JSON.stringify(url)}`);

  urlStr = urlStr
    .split("/")
    .map((urlPart) => {
      const dollar = /\$/;
      if (dollar.test(urlPart)) {
        const param = urlPart.replace(dollar, "");
        if (!urlParams.hasOwnProperty(param))
          throw new Error(
            `Missing param for url(${urlStr}): ${param}, supplied ${JSON.stringify(
              urlParams
            )}`
          );
        urlPart = urlParams[param];
      }
      return urlPart;
    })
    .join("/");
  try {
    return db(urlStr)
  } catch (error) {
    return null
  }
}

export function Value() {
  return [uuidv4()];
}

export function setDBSchema(schema) {
  refs = new Map();
  schemaToRefs(schema);
}

function db(...args) {
  const argArr = [...args];
  let fbRef;
  const dbRef = ref(getDatabase());
  if (argArr[1]) {
    fbRef = child(argArr[0], argArr[1]);
  } else if (argArr[0]) {
    fbRef = child(dbRef, argArr[0]);
  } else {
    fbRef = dbRef;
  }
  return fbRef;
}
